import { autoshopping } from './brands/autoshopping';
import { repasse } from './brands/repasse';
import { BrandConfig, TenantId } from './brands/types';

const brands: Record<TenantId, BrandConfig> = {
	repasse,
	autoshopping,
};

const resolveTenant = (): BrandConfig => {
	const id = (process.env.REACT_APP_TENANT || 'repasse').toLowerCase();

	if (id in brands) {
		return brands[id as TenantId];
	}

	return repasse;
};

/** Configuracao da marca ativa, selecionada via REACT_APP_TENANT em build-time. */
export const tenant: BrandConfig = resolveTenant();

/** Caminho base do deploy. Use para montar URLs de assets em public/. */
export const basePath = process.env.PUBLIC_URL ?? tenant.basePath;

/** Resolve um caminho de asset em public/ respeitando o PUBLIC_URL do build. */
export const asset = (path: string): string => {
	const normalized = path.startsWith('/') ? path : `/${path}`;
	return `${basePath}${normalized}`;
};

/** URL completa da logo da marca ativa. */
export const logoUrl = (): string => asset(`/images/${tenant.logoFile}`);
